import type { IconData } from '@stacksjs/iconify-core'

export const stream: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 112h336v32H16zm144 128h336v32H160zM16 368h336v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default stream
